export const it = {
  // App branding
  appName: 'Hekaya',

  // Navigation
  home: 'Home',
  forYou: 'Per te',
  myList: 'La mia lista',
  profile: 'Profilo',
  userProfile: 'Profilo utente',

  // Authentication
  signIn: 'Accedi',
  signUp: 'Registrati',
  signOut: 'Disconnetti',
  signInWithApple: 'Accedi con Apple',
  signUpWithApple: 'Registrati con Apple',
  signInWithGoogle: 'Accedi con Google',
  signUpWithGoogle: 'Registrati con Google',
  appleSignInFailed: 'Accesso con Apple non riuscito. Riprova.',
  appleAuthExpired: 'Codice Apple scaduto',
  appleAuthRetrying: 'Nuovo tentativo in corso...',
  appleAuthRetryFailed: 'Accesso con Apple non riuscito. Riprova.',
  appleAuthMaxRetriesReached: 'Troppi tentativi. Riprova più tardi.',
  appleSignInCancelled: 'Accesso con Apple annullato.',
  appleAccountAlreadyExists: 'Esiste già un account con questo ID Apple. Effettua l\'accesso.',
  appleAccountNotFound: 'Nessun account trovato con questo ID Apple. Registrati prima.',
  googleSignInFailed: 'Accesso con Google non riuscito. Riprova.',
  googleAuthRetrying: 'Nuovo tentativo in corso...',
  googleAuthMaxRetriesReached: 'Troppi tentativi. Riprova più tardi.',
  or: 'o',
  email: 'Email',
  emailOrPhone: 'Email o Telefono',
  enterEmail: 'Inserisci la tua email',
  enterEmailOrPhone: 'Inserisci la tua email o numero di telefono',
  emailOrPhonePlaceholder: 'email@esempio.com o +39612345678',
  signInRequired: 'Accesso richiesto',
  toWatchThisEpisode: 'Per guardare questo episodio',
  toAddEpisodeToFavorites: 'Per aggiungere questo episodio ai preferiti',
  pleaseSignInToWatch: 'Per favore accedi per guardare questo episodio',
  pleaseSignInToAddFavorite: 'Per favore accedi per aggiungere questo episodio ai preferiti',
  pleaseSignInToAddSerieFavorite: 'Per favore accedi per aggiungere questa serie ai preferiti',
  pleaseSignInToSubscribe: 'Per favore accedi per abbonarti',
  pleaseSignInToAccessRewards: 'Per favore accedi per accedere a tutte le funzionalità e monitorare le tue ricompense.',
  subscriptionRequired: 'Abbonamento richiesto',
  episodeRequiresPremium: 'Questo episodio richiede un abbonamento premium',

  // Force update
  updateRequired: 'Aggiornamento richiesto',
  currentVersion: 'Versione attuale',
  requiredVersion: 'Versione richiesta',
  updateNow: 'Aggiorna ora',
  appCannotBeUsedWithoutUpdate: 'L\'app non può essere utilizzata senza aggiornamento',
  forceUpdateDefaultMessage: 'È disponibile una nuova versione dell\'app. Aggiorna per continuare a utilizzare l\'app.',

  // Recommended update
  updateAvailable: 'Aggiornamento disponibile',
  recommendedVersion: 'Versione consigliata',
  updateButton: 'Aggiorna',
  laterButton: 'Più tardi',
  updateWillBeShownAgainIn24Hours: 'Questo aggiornamento verrà mostrato nuovamente tra 24 ore',
  recommendedUpdateMessage: 'È disponibile una nuova versione dell\'app con miglioramenti e nuove funzionalità. Ti consigliamo di aggiornare per un\'esperienza migliore.',

  // Errors
  error: 'Errore',
  pleaseFillAllFields: 'Per favore compila tutti i campi',
  failedToCreateAccount: 'Impossibile creare l\'account',
  invalidCredentials: 'Credenziali non valide',
  accountDisabled: 'Questo account è stato disabilitato',
  emailAlreadyExists: 'Questa email è già utilizzata da un altro account',
  phoneAlreadyExists: 'Questo numero di telefono è già utilizzato da un altro account',
  invalidEmailFormat: 'Inserisci un indirizzo email valido',
  invalidPhoneFormat: 'Inserisci un numero di telefono valido',
  accountMergeNotSupported: 'Esiste già un account con questo indirizzo email. Per favore accedi con il tuo metodo di accesso originale.',

  // Content
  searchDramas: 'Cerca drama...',
  noResultsFound: 'Nessun risultato trovato per "{query}"',
  searchResultsOne: '1 risultato per "{query}"',
  searchResultsMany: '{count} risultati per "{query}"',
  allSeries: 'Tutte le serie',
  topCharts: 'Classifiche',
  recommendedForYou: 'Consigliato per te',
  basedOnPreferences: 'In base alle tue preferenze',
  continueWatching: 'Continua a guardare',
  resumeWatching: 'Riprendi la visione',
  similarToWatched: 'Simile a quello che hai guardato',
  trendingSearches: 'Ricerche di tendenza',
  noSeriesInProgress: 'Nessuna serie in corso',
  startWatchingToSee: 'Inizia a guardare una serie per vederla qui',
  noContentAvailable: 'Nessun contenuto disponibile',
  checkSupabaseConfig: 'Per favore controlla la tua configurazione Supabase',

  // Series and episodes
  seasons: 'Stagioni',
  season: 'Stagione',
  episodes: 'Episodi',
  synopsis: 'Sinossi',
  episode: 'Episodio',
  play: 'Riproduci',
  swipeToSeeMore: 'Scorri per vedere di più',
  myListAction: 'La mia lista',
  addToMyList: 'Aggiungi ai preferiti',
  removeFromMyList: 'Rimuovi dai preferiti',
  popular: 'Popolare',
  new: 'Nuovo',
  trending: 'Di tendenza',
  highlight: 'In evidenza',
  free: 'Gratis',
  premium: 'Premium',
  premiumEpisode: 'Episodio Premium',
  signInToUnlock: 'Accedi per sbloccare',
  subscribeToWatch: 'Abbonati per guardare',

  // Profile
  subscribeToPremium: 'Passa a Premium',
  subscribeWithDCB: 'Passa a Premium con DCB',
  dcbSubscribeModalTitle: 'Abbonamento tramite pagamento mobile',
  dcbSubscribeLoading: 'Preparazione del pagamento...',
  dcbSubscribeError: 'Impossibile caricare la pagina di pagamento.',
  dcbSubscribeRetry: 'Riprova',
  restorePurchases: 'Ripristina Acquisti',
  purchaseProcessing: 'Elaborazione...',
  subscriptionActivated: 'Abbonamento attivato con successo!',
  webPaymentUnavailable: 'I pagamenti web non sono attualmente disponibili. Riprova più tardi.',
  paymentInitializing: 'Il sistema di pagamento si sta inizializzando. Riprova tra qualche secondo.',
  loadingOffers: 'Caricamento offerte...',
  purchasesRestored: 'Il tuo abbonamento è stato ripristinato con successo! Ora hai accesso a tutti i contenuti premium.',
  noPurchasesToRestore: 'Nessun abbonamento attivo trovato da ripristinare. Se ritieni che questo sia un errore, contatta l\'assistenza.',
  purchaseFailed: 'Acquisto non riuscito. Per favore riprova.',
  restoreFailed: 'Impossibile ripristinare gli acquisti.',
  noActiveSubscription: 'Nessun abbonamento attivo trovato da ripristinare.',
  iapNotAvailable: 'Gli acquisti in-app non sono disponibili.',
  webPurchaseNotSupported: 'Gli acquisti in-app non sono disponibili sul web. Per favore usa l\'app mobile.',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'Abbonamento Premium Mensile',
  premiumSubscriptionTagline: 'Sblocca l\'accesso illimitato a tutte le serie e gli episodi',
  whatYouGet: 'Cosa Ottieni',

  // Profile subscription information
  profileSubscriptionDescription: 'Ottieni accesso illimitato a tutte le serie drammatiche ed episodi con il nostro abbonamento mensile.',
  profileBenefit1: 'Guarda qualsiasi episodio dalla nostra libreria completa',
  profileBenefit2: 'Accesso istantaneo a tutti i nuovi episodi',
  profileBenefit3: 'Esperienza di visione senza pubblicità',

  premiumBenefit1: 'Accesso illimitato a tutte le serie drammatiche - guarda qualsiasi episodio, in qualsiasi momento',
  premiumBenefit2: 'Libreria completa di contenuti attuali con centinaia di episodi',
  premiumBenefit3: 'Accesso istantaneo a tutti i nuovi episodi non appena vengono pubblicati',
  premiumBenefit4: 'Guarda qualsiasi episodio senza restrizioni o limitazioni',
  premiumBenefit5: 'Esperienza di visione senza pubblicità per un intrattenimento ininterrotto',
  premiumBenefit6: 'Streaming video di alta qualità per la migliore esperienza di visione',
  premiumBenefit7: 'Accesso su tutti i tuoi dispositivi - telefono, tablet e web',
  bestValue: 'Miglior Valore',
  subscriptionIncludes: 'Accesso completo a tutti i contenuti',
  perMonth: '/mese',
  perWeek: '/settimana',
  startSubscription: 'Inizia Abbonamento',
  learnMoreAboutSubscription: 'Scopri di Più Sull\'Abbonamento',

  // Subscription terms
  subscriptionTerms: 'Ti verrà addebitato tramite il tuo account al prezzo mostrato nella schermata di abbonamento. L\'abbonamento si rinnova automaticamente ogni mese a meno che tu non lo annulli almeno 24 ore prima della data di rinnovo. Gli addebiti vengono effettuati 24 ore prima della fine del tuo periodo di fatturazione corrente.',

  // Subscription details modal
  subscriptionDetails: 'Dettagli Abbonamento',
  whatIsIncluded: 'Cosa È Incluso',
  subscriptionDetailsDescription: 'Il tuo abbonamento Premium mensile ti dà accesso illimitato a tutte le serie drammatiche ed episodi nella nostra libreria. Questo include tutti i contenuti attuali e tutti i nuovi episodi pubblicati durante il tuo periodo di abbonamento. Puoi guardare qualsiasi episodio, in qualsiasi momento, su qualsiasi dei tuoi dispositivi senza restrizioni.',
  howBillingWorks: 'Come Funziona la Fatturazione',
  billingDescription: 'Ti verrà addebitato tramite il tuo account al prezzo mostrato nella schermata di abbonamento. L\'abbonamento si rinnova automaticamente ogni mese a meno che tu non lo annulli almeno 24 ore prima della data di rinnovo. Gli addebiti avvengono 24 ore prima della fine del tuo periodo di fatturazione corrente.',
  howToCancel: 'Come Annullare',
  cancellationDescription: 'Puoi annullare il tuo abbonamento in qualsiasi momento andando nelle impostazioni del tuo dispositivo. Per iOS: Impostazioni > [Il Tuo Nome] > Abbonamenti. Per Android: Google Play Store > Menu > Abbonamenti. Seleziona questa app e tocca Annulla Abbonamento. Il tuo abbonamento rimane attivo fino alla fine del periodo di fatturazione corrente.',
  cancellationDescriptionIos: 'Puoi annullare il tuo abbonamento in qualsiasi momento andando nelle impostazioni del tuo dispositivo. Per iOS: Impostazioni > [Il Tuo Nome] > Abbonamenti. Seleziona questa app e tocca Annulla Abbonamento. Il tuo abbonamento rimane attivo fino alla fine del periodo di fatturazione corrente.',
  cancellationDescriptionAndroid: 'Puoi annullare il tuo abbonamento in qualsiasi momento andando nelle impostazioni del tuo dispositivo. Per Android: Google Play Store > Menu > Abbonamenti. Seleziona questa app e tocca Annulla Abbonamento. Il tuo abbonamento rimane attivo fino alla fine del periodo di fatturazione corrente.',
  subscriptionExpiry: 'Cosa Succede Quando Scade l\'Abbonamento',
  expiryDescription: 'Se annulli o il tuo abbonamento scade, perderai l\'accesso ai contenuti premium. Tuttavia, la tua cronologia di visualizzazione e i preferiti verranno salvati. Puoi riabbanarti in qualsiasi momento per riottenere l\'accesso completo a tutti gli episodi premium.',
  deviceCompatibility: 'Compatibilità Dispositivi',
  compatibilityDescription: 'Il tuo abbonamento funziona su tutte le piattaforme dove utilizzi lo stesso account. Accedi con lo stesso account su qualsiasi dispositivo per accedere ai tuoi vantaggi premium.',
  helpFeedback: 'Aiuto e feedback',
  language: 'Lingua',
  notifications: 'Notifiche',
  notificationSettings: 'Impostazioni notifiche',
  pushNotifications: 'Notifiche push',
  enabled: 'Attivato',
  disabled: 'Disattivato',
  enable: 'Attiva',
  enabling: 'Attivazione...',
  pushNotificationsEnabled: 'Notifiche push attivate con successo',
  pushNotificationsDisabled: 'Notifiche push disattivate',
  enablePushNotificationsInSettings: 'Per ricevere notifiche, attivale nelle impostazioni del dispositivo.',
  openSettings: 'Apri impostazioni',
  pushNotificationsEnabledDescription: 'Riceverai notifiche su questo dispositivo',
  pushNotificationsDisabledDescription: 'Attiva le notifiche per rimanere aggiornato',
  notificationCategories: 'Categorie di notifiche',
  notificationCategoriesDescription: 'Scegli quali tipi di notifiche vuoi ricevere',
  newEpisodes: 'Nuovi episodi',
  newEpisodesDescription: 'Ricevi notifiche quando vengono pubblicati nuovi episodi',
  recommendations: 'Raccomandazioni',
  recommendationsDescription: 'Suggerimenti di contenuti personalizzati per te',
  subscriptionReminders: 'Promemoria abbonamento',
  subscriptionRemindersDescription: 'Promemoria sullo stato del tuo abbonamento',
  rewardsNotifications: 'Premi e obiettivi',
  rewardsNotificationsDescription: 'Aggiornamenti sui tuoi premi e progressi',
  marketingNotifications: 'Marketing e promozioni',
  marketingNotificationsDescription: 'Offerte speciali e contenuti promozionali',
  failedToUpdatePreferences: 'Impossibile aggiornare le preferenze di notifica',
  failedToRequestPermission: 'Impossibile richiedere il permesso di notifica',
  signInToSavePreferences: 'Accedi per salvare le tue preferenze di notifica su tutti i dispositivi',
  done: 'Fatto',
  contactUs: 'Contattaci',
  settings: 'Impostazioni',
  privacyPolicy: 'Informativa sulla privacy',
  privacySettings: 'Privacy e Consenso',
  cookieSettings: 'Le mie impostazioni cookie',
  localStorage: 'Archiviazione locale',
  termsConditions: 'Termini e condizioni',
  legalNotice: 'Note legali',
  pricingConditions: 'Condizioni tariffarie',
  unsubscribe: 'Annulla abbonamento',
  unsubscribeInfo: 'Informazioni sulla cancellazione',
  loadingUnsubscribeInfo: 'Caricamento informazioni sulla cancellazione...',
  unsubscribeContentNotAvailable: 'Le informazioni sulla cancellazione non sono al momento disponibili.',
  dcbUnsubscribeButton: 'Annulla il mio abbonamento',
  dcbUnsubscribeConfirmTitle: 'Conferma',
  dcbUnsubscribeConfirmMessage: 'Sei sicuro di voler annullare il tuo abbonamento? Perderai l\'accesso ai contenuti premium.',
  dcbUnsubscribeSuccess: 'Il tuo abbonamento è stato annullato con successo. Non sei più abbonato al servizio.',
  dcbUnsubscribeError: 'Impossibile annullare il tuo abbonamento. Contatta il servizio clienti per ricevere assistenza.',
  loadingPrivacyPolicy: 'Caricamento informativa sulla privacy...',
  privacyPolicyNotAvailable: 'L\'informativa sulla privacy non è al momento disponibile.',
  loadingTermsConditions: 'Caricamento termini e condizioni...',
  termsConditionsNotAvailable: 'I termini e condizioni non sono al momento disponibili.',
  cookies: 'Cookies',
  cookiesSection: 'Cookies',
  legalSection: 'Informazioni legali',
  loadingCookies: 'Caricamento informazioni sui cookies...',
  cookiesNotAvailable: 'Le informazioni sui cookies non sono al momento disponibili.',
  loadingLegalNotice: 'Caricamento note legali...',
  legalNoticeNotAvailable: 'Le note legali non sono al momento disponibili.',
  loadingPricingConditions: 'Caricamento condizioni tariffarie...',
  pricingConditionsNotAvailable: 'Le condizioni tariffarie non sono al momento disponibili.',
  retry: 'Riprova',
  noEmailApp: 'Nessuna applicazione email disponibile su questo dispositivo.',
  errorOpeningEmail: 'Impossibile aprire l\'applicazione email.',
  errorOpeningSettings: 'Impossibile aprire le impostazioni di sistema.',
  security: 'Sicurezza',

  // Loading and errors
  loading: 'Caricamento...',
  loadingContent: 'Caricamento contenuto...',
  preparingVideo: 'Preparazione video...',

  seasonNotFound: 'Stagione non trovata',
  episodeNotFound: 'Episodio non trovato',
  rubriqueNotFound: 'Sezione non trovata',

  // Video player

  loadingVideo: 'Caricamento video...',
  loadingPlayer: 'Caricamento lettore...',
  loadingEpisodes: 'Caricamento episodi...',

  // Badges and labels
  min: 'min',
  enemiesToLovers: 'Da nemici ad amanti',

  // Actions
  cancel: 'Annulla',
  delete: 'Elimina',
  remove: 'Rimuovi',
  removeFromList: 'Rimuovi dalla mia lista',
  subscribe: 'Abbonati',
  selectLanguage: 'Seleziona lingua',
  restartRequired: 'Riavvio richiesto',
  restartMessage: 'Riavvia l\'applicazione per applicare la nuova direzione del layout.',
  restartToApplyLanguage: 'Riavviare l\'applicazione per applicare la nuova lingua?',
  ok: 'OK',
  save: 'Salva',
  saving: 'Salvataggio...',
  editProfile: 'Modifica profilo',
  pseudo: 'Pseudonimo',
  enterPseudo: 'Inserisci il tuo pseudonimo',
  pseudoPlaceholder: 'Scegli un nome unico (max 16 car.)',
  pseudoTaken: 'Questo pseudonimo è già in uso',
  pseudoInvalid: 'Questo pseudonimo contiene contenuti inappropriati',
  pseudoInvalidCharacters: 'Questo pseudonimo contiene caratteri non validi',
  pseudoNotAccepted: 'Si prega di scegliere un altro pseudonimo, questo non può essere accettato',
  pseudoMaxLength: 'Lo pseudonimo deve essere di massimo 16 caratteri',
  pseudoCharactersCount: '{{count}}/16 caratteri',
  editPseudo: 'Modifica pseudonimo',
  pseudoUpdated: 'Pseudonimo aggiornato con successo',
  subtitles: 'Sottotitoli',
  off: 'Disattivato',
  noSubtitlesAvailable: 'Nessun sottotitolo disponibile',
  playbackSpeed: 'Velocità di riproduzione',
  normalSpeed: 'Normale',
  profileInformation: 'Informazioni profilo',
  dateOfBirth: 'Data di nascita',
  phoneNumber: 'Numero di telefono',
  enterPhoneNumber: 'Inserisci il tuo numero di telefono',
  notProvided: 'Non fornito',
  dateFormatHint: 'Formato: {format} (es: {example})',
  dateFormatPattern: 'GG-MM-AAAA',
  dateFormatExample: '31-12-1990',
  invalidDateFormat: 'Si prega di utilizzare il formato: {format}',
  invalidDate: 'Data non valida',

  // Placeholders and descriptions
  discoverGenre: 'Scopri',

  // Time and duration
  m: 'M', // Million views abbreviation
  now: 'ora',
  minuteAbbrev: 'min',
  hourAbbrev: 'h',
  dayAbbrev: 'g',
  monthAbbrev: 'mese',

  // History and viewing progress
  noViewingHistory: 'Nessuna cronologia di visualizzazione',
  episodesWillAppearHere: 'Gli episodi che guardi appariranno qui',
  history: 'Cronologia',
  series: 'Serie',
  noFavoritesYet: 'Nessun preferito ancora',
  addContentToFavorites: 'Aggiungi serie ed episodi ai tuoi preferiti per vederli qui',

  // My Purchases
  myPurchases: 'I Miei Acquisti',
  purchased: 'Acquistato',
  myPurchasesTitle: 'I Tuoi Episodi Sbloccati',
  myPurchasesDescription: 'Trova qui tutti gli episodi premium che hai sbloccato con le tue monete. Continua a guardare per guadagnare più monete!',
  tutorialStep1Title: 'Guarda episodi',
  tutorialStep1Description: 'Guadagna monete guardando contenuti gratuiti sulla piattaforma.',
  tutorialStep2Title: 'Accumula ricompense',
  tutorialStep2Description: 'Completa sfide e accedi quotidianamente per guadagnare ancora più monete.',
  tutorialStep3Title: 'Sblocca contenuti premium',
  tutorialStep3Description: 'Usa le tue monete per sbloccare episodi premium esclusivi.',
  goToRewards: 'Vai alle ricompense',

  // Gamification notifications
  userSignupNotification: 'Benvenuto! Hai guadagnato {coins} monete per aver creato il tuo account!',
  dailyVisitNotification: 'Hai guadagnato {coins} monete per la tua visita giornaliera!',
  emailProvidedNotification: 'Hai guadagnato {coins} monete per aver fornito la tua email!',
  msisdnProvidedNotification: 'Hai guadagnato {coins} monete per aver fornito il tuo numero di telefono!',
  birthDateProvidedNotification: 'Hai guadagnato {coins} monete per aver fornito la tua data di nascita!',
  completeProfileNotification: 'Hai guadagnato {coins} monete per aver completato il tuo profilo!',
  pseudoProvidedNotification: 'Hai guadagnato {coins} monete per aver creato uno pseudonimo personalizzato!',
  selectImageSource: 'Seleziona sorgente immagine',
  takePhoto: 'Scatta foto',
  chooseFromLibrary: 'Scegli dalla galleria',
  removeProfilePicture: 'Rimuovi foto profilo',
  removeProfilePictureConfirm: 'Sei sicuro di voler rimuovere la tua foto profilo?',
  profilePictureUpdated: 'Foto profilo aggiornata con successo',
  profilePictureRemoved: 'Foto profilo rimossa con successo',
  failedToPickImage: 'Errore nella selezione dell\'immagine dalla galleria',
  failedToTakePhoto: 'Errore nello scattare la foto',
  failedToUploadImage: 'Errore nel caricamento dell\'immagine. Riprova.',
  imageInappropriateContent: 'L\'immagine contiene contenuti inappropriati',
  failedToUpdateProfilePicture: 'Errore nell\'aggiornamento della foto profilo',
  failedToRemoveProfilePicture: 'Errore nella rimozione della foto profilo',
  remove: 'Rimuovi',
  watchEpisodeNotification: 'Hai guadagnato {coins} monete per aver guardato un episodio!',
  watchAdsNotification: 'Hai guadagnato {coins} monete per aver guardato annunci!',
  enableNotificationsNotification: 'Hai guadagnato {coins} monete per aver attivato le notifiche!',
  followSocialNotification: 'Hai guadagnato {coins} monete per averci seguito sui social media!',
  coinsEarnedNotification: 'Hai guadagnato {coins} monete!',
  coinsUsedForPremiumNotification: 'Hai usato {coins} monete per sbloccare questo episodio premium!',
  firstCoinsUsageNotification: 'Benvenuto! Hai appena sbloccato il tuo primo episodio premium con le monete!',

  // Reward Center
  rewardCenter: 'Centro Ricompense',
  rewards: 'Ricompense',
  weeklyRanking: 'Classifica Settimanale',
  hallOfFame: 'Hall of Fame',
  thisWeeksTopPlayers: 'I Migliori Giocatori di Questa Settimana',
  allTimeChampions: 'Campioni di Sempre',
  totalCoinsAllTime: 'monete totali',
  coinsThisWeek: 'monete questa settimana',
  achievements: 'risultati',
  dayStreakRecord: 'giorni consecutivi',
  you: 'Tu',
  noRankingData: 'Nessun dato di classifica disponibile',
  checkBackLaterRanking: 'Torna più tardi per le classifiche settimanali',
  noHallOfFameData: 'Nessun dato della hall of fame disponibile',
  checkBackLaterHallOfFame: 'Torna più tardi per le classifiche di sempre',
  coins: 'Monete',
  days: 'giorni',
  dailyCheckIn: 'Check-in Giornaliero',
  earnRewards: 'Guadagna Ricompense',
  completed: 'Completato',
  claim: 'Da fare',
  comingSoon: 'Prossimamente',
  day: 'Giorno',
  today: 'Domani',
  totalCoins: 'Monete Totali',
  getCoins: 'Guadagna Monete,',
  keepWatching: 'Continua a Guardare',
  dayStreak: 'Giorni Consecutivi',
  nextReward: 'Prossima ricompensa',
  availableTomorrow: 'Disponibile domani',
  weekProgress: 'Progresso settimanale',
  serie: 'Serie',
  won: 'Vinto',
  tomorrow: 'Domani',
  toDo: 'Da Fare',
  firstWeek: 'Prima Settimana',
  secondWeek: 'Seconda Settimana',
  amazingStreak: 'Serie incredibile! Continua così!',
  overallProgress: 'Progresso Complessivo',
  of: 'di',
  eventsCompleted: 'eventi completati',
  ofMissionsCompleted: 'delle missioni completate',

  // Gamification event categories
  gamificationCategoryUser: 'Utente',
  gamificationCategoryProfile: 'Profilo',
  gamificationCategoryContent: 'Contenuto',
  gamificationCategoryGeneral: 'Generale',
  gamificationCategoryDailyMission: 'Missione giornaliera',
  gamificationCategoryWelcomeMissions: 'Missioni di benvenuto',
  gamificationCategoryWatchMissions: 'Missioni di visione',
  gamificationCategoryOnceAYear: 'Una volta all\'anno',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'Completa missioni e guadagna monete!',
  gamificationFeature1Title: 'Creare il tuo account',
  gamificationFeature1Desc: 'Ricevi {{coins}} monete di benvenuto alla registrazione',
  gamificationFeature2Title: 'Guarda gli episodi',
  gamificationFeature2Desc: 'Guadagna {{coins}} monete per ogni episodio completato',
  gamificationFeature3Title: 'Scala la classifica',
  gamificationFeature3Desc: 'Confrontati con gli altri membri ogni settimana',
  gamificationFeature4Title: 'Sblocca episodi premium',
  gamificationFeature4Desc: 'Usa le tue monete per guardare ancora piu episodi',
  gamificationBonusText: '+{{coins}} monete gratis alla registrazione!',
  createAccount: 'Crea il mio account',
  connectToYou: 'Accedi',

  // All Episodes Control
  allEpisodes: 'Tutti gli episodi',
  watchNow: 'Guarda ora',
  previousEpisode: 'Precedente',
  nextEpisode: 'Successivo',

  // App availability
  appNotAvailable: 'Questa applicazione non è ancora disponibile nel tuo paese e nella tua lingua.',
  appNotAvailableSubtext: 'Stiamo lavorando per espandere il nostro servizio a più regioni.',

  // Biometric authentication
  biometricLogin: 'Accesso Biometrico',
  signInWithBiometric: 'Accedi con biometria',
  signInWithWebAuthn: 'Accedi con WebAuthn',
  signInWithFaceId: 'Accedi con Face ID',
  signInWithTouchId: 'Accedi con Touch ID',
  enableBiometric: 'Attiva accesso biometrico',
  disableBiometric: 'Disattiva accesso biometrico',
  biometricNotAvailable: 'L\'autenticazione biometrica non è disponibile su questo dispositivo',
  biometricAuthFailed: 'Autenticazione biometrica non riuscita',
  biometricDataMissing: 'I dati di accesso biometrico mancano. Per favore accedi con OTP, poi riattiva l\'accesso biometrico nelle impostazioni del profilo.',
  biometricNoUserData: 'Per favore accedi prima, poi attiva l\'accesso biometrico nelle impostazioni del profilo.',
  biometricUnexpectedError: 'Si è verificato un errore imprevisto. Per favore accedi con OTP, poi riattiva l\'accesso biometrico nelle impostazioni del profilo.',
  biometricAuthCancelled: 'L\'autenticazione biometrica è stata annullata. Per favore riprova.',
  webauthnNotEnabled: 'Per favore accedi prima, poi attiva l\'accesso WebAuthn nelle impostazioni del profilo.',
  webauthnCancelled: 'L\'autenticazione WebAuthn è stata annullata. Per favore riprova.',
  webauthnFailed: 'Autenticazione WebAuthn non riuscita',
  biometricLoginEnabled: 'L\'accesso biometrico è stato attivato',
  biometricLoginDisabled: 'L\'accesso biometrico è stato disattivato',
  webauthnLoginEnabled: 'L\'accesso WebAuthn è stato attivato',
  webauthnLoginDisabled: 'L\'accesso WebAuthn è stato disattivato',
  // iOS-specific labels (use branded terminology)
  faceIdLoginEnabled: 'L\'accesso Face ID è stato attivato',
  faceIdLoginDisabled: 'L\'accesso Face ID è stato disattivato',
  touchIdLoginEnabled: 'L\'accesso Touch ID è stato attivato',
  touchIdLoginDisabled: 'L\'accesso Touch ID è stato disattivato',
  // Android-specific labels (use generic biometric terminology)
  androidBiometricLoginEnabled: 'L\'accesso biometrico è stato attivato',
  androidBiometricLoginDisabled: 'L\'accesso biometrico è stato disattivato',
  failedToEnableBiometric: 'Impossibile attivare l\'accesso biometrico',
  failedToDisableBiometric: 'Impossibile disattivare l\'accesso biometrico',
  failedToEnableWebauthn: 'Impossibile attivare l\'accesso WebAuthn',
  failedToDisableWebauthn: 'Impossibile disattivare l\'accesso WebAuthn',
  success: 'Successo',
  enableBiometricPrompt: 'Attivare l\'autenticazione biometrica per un accesso rapido la prossima volta?',
  enableBiometricPromptIos: 'Attivare {authType} per un accesso rapido la prossima volta?',
  'Enable {{authType}}?': 'Attivare {{authType}}?',
  'Would you like to enable {{authType}} for faster login?': 'Vuoi attivare {{authType}} per un accesso più rapido?',
  '{{authType}} login has been enabled!': 'L\'accesso {{authType}} è stato attivato!',
  'Failed to enable {{authType}} login. Please try again later.': 'Impossibile attivare l\'accesso {{authType}}. Per favore riprova più tardi.',
  biometricLoginTitle: 'Accesso Biometrico',
  faceIdLogin: 'Accesso Face ID',
  touchIdLogin: 'Accesso Touch ID',
  useBiometricToSignIn: 'Usa impronta digitale o riconoscimento facciale per accedere rapidamente',
  enableBiometricForSignIn: 'Attiva impronta digitale o riconoscimento facciale per un accesso rapido',
  useFaceIdToSignIn: 'Usa Face ID per accedere rapidamente',
  enableFaceIdForSignIn: 'Attiva Face ID per un accesso rapido',
  useTouchIdToSignIn: 'Usa Touch ID per accedere rapidamente',
  enableTouchIdForSignIn: 'Attiva Touch ID per un accesso rapido',

  // Delete account
  deleteMyAccount: 'Elimina il mio account',
  deleteAccountConfirmation: 'Conferma eliminazione',
  deleteAccountWarningNotSubscribed: 'Procederemo con l\'eliminazione del tuo account. Non potrai più accedere a Hekaya dopo aver confermato.\n\nTuttavia, tieni presente che in conformità con le normative, conserviamo in modo sicuro alcuni dati, ad esempio per eventuali scopi di risoluzione delle controversie.',
  deleteAccountWarningSubscribed: 'Attualmente hai un abbonamento attivo. Per favore cancellalo prima. Troverai le istruzioni per l\'annullamento in "Il mio account", "Disiscriviti". Una volta cancellato l\'abbonamento, potrai procedere con l\'eliminazione del tuo account.\n\nProcederemo con l\'eliminazione del tuo account. Non potrai più accedere a Hekaya dopo aver confermato.\n\nTuttavia, tieni presente che in conformità con le normative, conserviamo in modo sicuro alcuni dati, ad esempio per eventuali scopi di risoluzione delle controversie.',
  iConfirm: 'Confermo',
  deletingAccount: 'Eliminazione account...',
  accountDeleted: 'Account eliminato',
  accountDeletedSuccess: 'Il tuo account è stato eliminato con successo',
  accountDeleteError: 'Errore durante l\'eliminazione dell\'account',
  activeSubscriptionErrorTitle: 'Abbonamento attivo',
  activeSubscriptionErrorMessage: 'Devi annullare il tuo abbonamento prima di poter eliminare il tuo account.',
  gracePeriodErrorTitle: 'Eliminazione non disponibile al momento',
  gracePeriodErrorMessage: 'Il tuo abbonamento e stato annullato, ma rimane attivo fino alla data di scadenza. Potrai eliminare il tuo account al termine di questo periodo.',
  gracePeriodBannerTitle: 'Abbonamento annullato',
  gracePeriodBannerMessage: 'Il tuo abbonamento e stato annullato ma rimane attivo fino al {{date}}. Mantieni l\'accesso a tutti i contenuti premium fino a quella data.',
  notBilledDenyBannerTitle: 'Abbonamento sospeso',
  notBilledDenyBannerMessage: 'Il tuo abbonamento e stato temporaneamente sospeso a causa di un problema di pagamento. Per ripristinare l\'accesso al nostro servizio, ricarica il tuo account *9. Il tuo account Hekaya verra riattivato una volta elaborato il pagamento.',

  // Network connection
  noInternetConnection: 'Nessuna connessione Internet disponibile. Per favore controlla la tua connessione e riprova.',
  noInternetConnectionShort: 'Nessuna connessione Internet',
  checkInternetConnection: 'Per favore controlla la tua connessione Internet',
  connectionRequired: 'Connessione Internet richiesta',
  dismiss: 'Continua offline',
  slowNetworkDetected: 'Rete lenta rilevata',
  poorNetworkConnection: 'La tua connessione di rete sta riscontrando problemi. Il caricamento del video sta richiedendo più tempo del solito.',
  loadingTime: 'Tempo di caricamento',
  slowConnection: 'Connessione lenta',
  retry: 'Riprova',

  // Image Cache Storage
  imageCacheStorage: 'Archiviazione cache immagini',
  cachedImages: 'Immagini in cache',
  storageUsed: 'Spazio utilizzato',
  expiredImages: 'Immagini scadute',
  clearExpiredCache: 'Cancella scadute',
  clearAllCache: 'Cancella tutto',
  clearing: 'Cancellazione...',
  clearImageCache: 'Cancella cache immagini',
  clearImageCacheConfirmation: 'Sei sicuro di voler cancellare tutte le immagini in cache? Questo libererà spazio di archiviazione ma le immagini dovranno essere scaricate di nuovo.',
  clearCache: 'Cancella cache',
  cacheCleared: 'Cache cancellata con successo! {{count}} immagini rimosse.',
  expiredCacheCleared: 'Cache scaduta cancellata! {{count}} immagini scadute rimosse.',
  noExpiredCache: 'Nessuna immagine scaduta da cancellare.',
  failedToClearCache: 'Impossibile cancellare la cache. Riprova.',
  cacheAutoClears30Days: 'Le immagini vengono cancellate automaticamente dopo 30 giorni',
  info: 'Info',

  // App version
  version: 'Versione',

  // Pagination
  scrollForMore: 'Scorri per vedere di piu',
  noMoreContent: 'Fine della lista',
  loadingMore: 'Caricamento...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'Accedi o crea un account gratuito',
    subscriptionWelcomeTitle: 'Grazie per il tuo abbonamento!',
    subscriptionWelcomeMessage: 'Ultimo passaggio: registrati per creare un account o accedi a uno esistente per iniziare a guardare i drama.',
    emailPlaceholder: 'Indirizzo e-mail',
    phonePlaceholder: 'Numero di telefono',
    emailOrPhonePlaceholder: 'Email o Numero di telefono',
    continue: 'Continua',
    continueWithGoogle: 'Continua con Google',
    continueWithApple: 'Continua con Apple',
    termsPrefix: 'Continuando, accetti i nostri',
    termsOfService: 'Termini di servizio',
    privacyPolicy: 'Informativa sulla privacy',
    confirmEmail: 'Conferma indirizzo e-mail',
    confirmYourEmail: 'Conferma il tuo indirizzo e-mail',
    confirmPhone: 'Conferma numero di telefono',
    confirmYourPhone: 'Conferma il tuo numero di telefono',
    codeSentTo: 'Abbiamo inviato un codice a',
    codeSentToPhone: 'Abbiamo inviato un codice al',
    enterCodeBelow: 'Inseriscilo qui sotto per verificare il tuo account.',
    resendCode: 'Reinvia codice',
    resendIn: 'Reinvia tra',
    verify: 'Verifica',
    connectingInProgress: 'Connessione in corso...',
    accountCreated: 'Account creato',
    stayUpdatedTitle: 'Vorresti rimanere aggiornato sulle ultime novita?',
    stayUpdatedDescription: 'Ci piacerebbe inviarti offerte personalizzate, contenuti ispiranti, consigli sui dispositivi e informazioni sulle nostre ultime innovazioni.',
    learnMore: 'Scopri di piu',
    subscribe: 'Iscriviti',
    noThanks: 'No grazie',
    enterEmailOrPhone: 'Inserisci la tua e-mail o numero di telefono',
    sendFailed: 'Invio del codice fallito. Riprova.',
    enterCompleteCode: 'Inserisci il codice completo di 6 cifre',
    verificationFailed: 'Verifica fallita. Riprova.',
    invalidCode: 'Codice non valido. Riprova.',
    codeExpired: 'Il codice e scaduto. Richiedine uno nuovo.',
    checkSpamFolder: 'Ricorda di controllare la cartella spam',
    dcbValidatingSubscription: 'Convalida dell\'abbonamento in corso...',
    dcbActivating: 'Attivazione dell\'abbonamento in corso...',
    dcbSuccessTitle: 'Abbonamento attivato!',
    dcbSuccessMessage: 'Il tuo abbonamento e stato attivato con successo. Ora puoi goderti tutti i contenuti.',
    dcbStartWatching: 'Inizia a guardare',
    dcbErrorTitle: 'Errore di attivazione',
    dcbErrorRetry: 'Si e verificato un errore durante l\'attivazione dell\'abbonamento. Riprova.',
    dcbPaymentNotFound: 'Abbonamento non trovato. Verifica il tuo link o contatta il supporto.',
    dcbRetryButton: 'Riprova',
    dcbIdentityMismatchPhone: 'Il numero utilizzato per l\'abbonamento e {{identifier}}. Utilizza questo numero per creare il tuo account.',
    dcbIdentityMismatchEmail: 'L\'email utilizzata per l\'abbonamento e {{identifier}}. Utilizza questa email per creare il tuo account.',
    dcbRecoveryBanner: 'E stato rilevato un abbonamento in sospeso. Crea il tuo account per accedervi.',
    dcbAlreadySubscribed: 'Gia abbonato tramite pagamento mobile?',
    dcbEnterPhone: 'Inserisci il numero di telefono utilizzato durante il pagamento:',
    dcbRecoverButton: 'Recupera',
    dcbMsisdnNotFound: 'Nessun abbonamento in sospeso trovato per questo numero.',
    dcbMsisdnRecoveryFailed: 'Errore durante il recupero. Per favore riprova.',
    invalidPhoneNumber: 'Numero di telefono non valido.',
  },
  and: 'e',
  smartBannerSubtitle: 'Esperienza migliore nell\'app',
  smartBannerOpen: 'APRI',
  paymentVerifying: 'Verifica dell\'abbonamento in corso...',
  paymentSuccessTitle: 'Abbonamento attivato!',
  paymentSuccessMessage: 'Congratulazioni, ora hai accesso a tutti i contenuti Premium.',
  paymentSuccessButton: 'Inizia a guardare',
  paymentPendingMessage: 'Il tuo pagamento \u00e8 stato ricevuto. Il tuo abbonamento sar\u00e0 attivo a breve.',
  paymentRefreshButton: 'Aggiorna',
  redirectingToPayment: 'Reindirizzamento alla pagina di pagamento...',
  webPaymentIframeErrorTitle: 'Pagina di pagamento non disponibile',
  webPaymentIframeErrorMessage: 'La pagina di pagamento non \u00e8 stata caricata nell\'app. Puoi aprirla in una nuova scheda.',
  webPaymentOpenExternal: 'Apri in una nuova scheda',

  // Premium subscription card
  enterPremiumExperience: 'Entra nell\'esperienza',
  popular: 'POPOLARE',
  mobileInvoice: 'Fattura Mobile',
  mobileInvoicePrice: '\u20ac9,99/mese',
  mobileInvoiceDescription: 'Pagamento sulla tua bolletta telefonica. Semplice e Veloce.',
  cardAppleGooglePay: 'Carta / Apple Pay / Google Pay',
  cardPaymentDescription: 'Pagamento sicuro con carta, Apple Pay o Google Pay.',
  dcbPaymentOfferDescription: 'Pagamento sulla bolletta telefonica. Semplice e veloce.',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'Abbonamento addebitato e gestito tramite il tuo account Apple App Store.',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'Abbonamento addebitato e gestito tramite il tuo account Google Play Store.',
  upgradeToPremium: 'Passa a Premium',
  cancelAnytimeNoCommitment: 'Cancella in qualsiasi momento \u00b7 Senza impegno',
  whyBecomeVip: 'Perch\u00e9 diventare VIP?',
  joinPremiumCommunity: 'Unisciti alla nostra comunit\u00e0 Premium Hekaya',
  unlimitedAccessShort: 'Accedi senza limiti a tutte le serie e gli episodi.\nGuarda quando vuoi, dove vuoi.',

  // DCB subscription details (profile view)
  dcbOfferDaily: 'Abbonamento giornaliero',
  dcbOfferWeekly: 'Abbonamento settimanale',
  dcbOfferMonthly: 'Abbonamento mensile',
  dcbOfferQuarterly: 'Abbonamento trimestrale',
  dcbOfferYearly: 'Abbonamento annuale',
  dcbOfferRecurring: 'Abbonamento ricorrente',
  dcbSubscriptionValidity: 'Valido fino al {{date}}',
};
